"use client";

import { useMounted } from "@/hooks/useMounted";
import { getStoredUtms } from "@/utils/utm";

interface SplashFormProps {
  eventId?: string;
  theme?: string;
  minHeight?: number;
  unavailableLabel?: string;
}

export default function SplashForm({
  eventId = "",
  theme = "default",
  minHeight = 404,
  unavailableLabel = "Form currently unavailable.",
}: SplashFormProps) {
  const mounted = useMounted();

  if (!eventId) return <p>{unavailableLabel}</p>;
  if (!mounted)
    return (
      <div
        className={`splash-form-container block relative overflow-hidden theme-${theme}`}
        style={{ minHeight: `${minHeight}px` }}
        aria-hidden="true"
      />
    );

  const utms = getStoredUtms();
  const params = new URLSearchParams();
  Object.entries(utms).forEach(([key, value]) => {
    if (value) params.set(key, value);
  });
  const query = params.toString();
  const src = `https://events.isovalent.com/${eventId}${query ? `?${query}` : ""}`;

  return (
    <div
      className={`splash-form-container block relative overflow-hidden theme-${theme}`}
      style={{ minHeight: `${minHeight}px` }}
    >
      <iframe
        src={src}
        width="100%"
        height="100%"
        title="Isovalent Splash Form"
        className="block relative w-full h-full border-0 overflow-hidden"
      ></iframe>
    </div>
  );
}
